<template>
    <div class="VRadioSwitcher">
        <template v-if="type.toLowerCase() === 'array'">
            <div
                class="radio"
                v-for="(option,optionIndex) in options"
                :key="option.name"
                @mousedown="chooseOptionArray(optionIndex)"
                :class="{'radio_active':option.isSelected}"
            >
                <div class="button">
                    <div class="button__point"></div>
                </div>
                <div class="label">{{ option.name }}</div>
            </div>
        </template>
        <template v-if="type.toLowerCase() === 'object'">
            <div
                class="radio"
                v-for="(optionValue, optionName, optionIndex) in options"
                :key="optionIndex"
                @mousedown="chooseOptionObject(optionName)"
                :class="{'radio_active':optionValue.isSelected}"
            >
                <div class="button">
                    <div class="button__point"></div>
                </div>
                <div class="label">{{ optionName }}</div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'VRadioSwitcher',
        props: {
            options: {
                type: [Array, Object],
                required: true,
            },
            type: {
                type: String,
                default: 'array',
                validator: function (value) {
                    return ['array', 'object'].includes(value.toLowerCase());
                },
            },
            sync: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                localOptions: [],
            };
        },
        watch: {
            options: {
                deep: true,
                immediate: true,
                handler(newOptions) {
                    this.localOptions = _.cloneDeep(newOptions);
                },
            },
        },
        methods: {
            chooseOptionArray(optionIndex) {
                if (this.sync) {
                    this.localOptions.forEach((option) => {
                        option.isSelected = false;
                    });
                    this.localOptions[optionIndex].isSelected = true;
                    this.$emit('update:options', this.localOptions);
                } else if (!this.localOptions[optionIndex].isSelected) {
                    this.$emit('updateOptions', optionIndex, this.localOptions[optionIndex]);
                }
            },
            chooseOptionObject(optionName) {
                if (this.sync) {
                    Object.entries(this.localOptions).forEach(([key]) => {
                        if (optionName !== key) {
                            this.localOptions[key].isSelected = false;
                        } else {
                            this.localOptions[key].isSelected = true;
                        }
                    });
                    this.$emit('update:options', this.localOptions);
                } else {
                    this.$emit('updateOptions', optionName);
                }
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VRadioSwitcher {
        display: flex;
        
        .radio {
            display: flex;
            align-items: center;
            margin-left: 5px;
            margin-right: 5px;
            
            &_active {
                .button {
                    &__point {
                        background: $primary-color;
                    }
                }
            }
            
            .button {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 19px;
                height: 19px;
                border-radius: 50%;
                border: 1px solid $primary-color;
                margin-right: 5px;
                cursor: pointer;
                &__point {
                    height: 17px;
                    width: 17px;
                    border-radius: 50%;
                }
            }
        }
    }
</style>
